<template>
    <master-layout>

        <!-- Breadcamb -->
        <div class="breadcamb_box bread_buttons">
            <div>
                <h4 class="page-title"><i class="ti-pie-chart"></i> {{ $t('dashboard') }}</h4>
            </div>
            <div>
                <router-link :to="{ name: 'deals.index' }" class="btn_mobile_block btn btn_green">
                    <span class="btn-label">
                        <i class="fa-fw icon-directions"></i>
                    </span>
                    {{ $t('deals') }}
                </router-link>
                <router-link :to="{ name: 'kanban.index' }" class="btn_mobile_block btn btn-inverse">
                    <span class="btn-label">
                        <i class="fa-fw md-dashboard"></i>
                    </span>
                    {{ $t('pipeline') }}
                </router-link>
            </div>
        </div>
        <div>
            <PmlNumbers></PmlNumbers>

            <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4">
                    <PmlIsolatedDeals></PmlIsolatedDeals>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4">
                    <PmlRecentFollowUps></PmlRecentFollowUps>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4">
                    <PmlNextTasks></PmlNextTasks>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <PmlLastEmailInteractions></PmlLastEmailInteractions>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <PmlNextScheduledEmails></PmlNextScheduledEmails>
                </div>
            </div>

            <div class="row">
                 <div class="col-md-12">
                    <PmlEmails></PmlEmails>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <PmlFollowUps></PmlFollowUps>
                </div>
            </div>
        </div>

    </master-layout>
</template>

<script>
    import PmlFollowUps from './widgets/FollowUps.vue'
    import PmlNumbers from './widgets/Numbers.vue'
    import PmlEmails from './widgets/Emails.vue'
    import PmlIsolatedDeals from './widgets/LastDeals.vue'
    import PmlRecentFollowUps from './widgets/LastFollowUps.vue'
    import PmlNextTasks from './widgets/OpenTasks.vue'
    import PmlLastEmailInteractions from './widgets/LastEmailInteractions.vue'
    import PmlNextScheduledEmails from './widgets/NextScheduledEmails.vue'
    import {getAmountDeals} from 'services/dashboard'

    export default {
        name: 'Dashboard',
        components: {
            PmlFollowUps,
            PmlNumbers,
            PmlEmails,
            PmlIsolatedDeals,
            PmlRecentFollowUps,
            PmlNextTasks,
            PmlLastEmailInteractions,
            PmlNextScheduledEmails
        },
        beforeRouteEnter (to, from, next) {
            getAmountDeals()
                .then(response => {
                    next(vm => {
                        if (response.data === 0)
                            vm.$router.push({name: 'dashboard.first-deal'})
                    })
                })
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/dashboard/components/Main.vue